import React, { useEffect, useRef } from "react";

import { CButton } from "@coreui/react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useParams, useLocation, useNavigate } from "react-router-dom";

//components
import Box from "../components/Box";
import DocDropzone from "../components/DocDropzone";
import BoxCustomerMenu from "../components/BoxCustomerMenu";
import BoxProfilePicture from "../components/BoxProfilePicture";

import * as yup from "yup";
import useAxios from "../hooks/useAxios";
import useAxiosFunction from "../hooks/useAxiosFunction";
import axiosInstance from "../apis/gvmdesk";
import InputControlledMask from "../components/Forms/InputControlledMask";
import { Input, Spinner } from "../components";
import LoadingCenter from "../components/LoadingCenter";
import openToast from "../utils/sweetAlert";

const schema = yup.object({
  number: yup.string().required("Você precisa preencher um número de telefone!"),
  phone: yup.string().required("O campo telefone precisa ser preenchido!").nullable()
}).required();

const nameSchema = yup.object({
  name: yup.string().required("Você precisa preencher o campo nome!")
}).required();

const CustomersDetails = props => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const inputFilesRef = useRef(null);

  const [phoneResponse, setPhoneResponse, phoneLoading, phoneError, axiosFetch] = useAxiosFunction();
  const [nameResponse, setNameResponse, nameLoading, nameError, nameAxiosFetch] = useAxiosFunction();

  const [user, setUser, loading, error, refetch] = useAxios({ axiosInstance, method: "GET", url: "/users/" + params.id });
  const [docs, setDocs, docsLoading, docsError, docsRefetch] = useAxios({ axiosInstance, method: "GET", url: "/users/documents/" + params.id });

  const sendNumber = async (data) => {
    const { phone, number } = data;

    axiosFetch({
      axiosInstance,
      method: "POST",
      url: "/users/edit/phone/" + params.id,
      redirect_to: "",
      data: {
        phone,
        body: number
      }
    });
  };

  useEffect(() => {
    if (phoneResponse?.data?.error) {
      openToast("error", "Erro", phoneResponse?.data.message);
    }
  }, [phoneResponse]);

  const { register, handleSubmit, control, formState: { errors } } = useForm({ resolver: yupResolver(schema) });

  const { register: nameRegister, setValue, handleSubmit: handleSubmitName, formState: { errors: errorsName } } = useForm({
    resolver: yupResolver(nameSchema),
    defaultValues: {
      name: user.name
    }
  });

  if (!loading && user) {
    setValue("name", user?.name);
  }

  const btnLoading = phoneLoading
    ? <Spinner />
    : "Enviar número";

  const handleSetName = data => {
    nameAxiosFetch({
      axiosInstance,
      method: "POST",
      url: "users/edit/name/" + user.id,
      data
    });
  }

  if (loading) return <LoadingCenter />;

  return (
    !loading &&
    <div className="d-flex flex-column align-center justify-center">
      <div className="inner-profile-xl">
        <BoxProfilePicture user={user} />

        {user?.usadao_id != "" && <BoxCustomerMenu user={user} />}

        {user?.usadao_id == "" && <Box title="Editar o nome do cliente">
          <form onSubmit={handleSubmitName(handleSetName)}>
            <Input label="Nome" type="text" name="name" register={nameRegister} error={errorsName.name} />

            <div className="d-flex flex-row justify-end">
              <CButton type="submit" color="dark" className="mt-20">Atualizar nome</CButton>
            </div>
          </form>
        </Box>}

        {user?.usadao_id != "" && <Box title="Enviar documento" onClick={() => inputFilesRef.current.openFiles()} defaultOpen={true}>
          <DocDropzone ref={inputFilesRef} user={user} />

          {docs && <div className="mt-20">
            <ul className="doc__list">
              {docs?.map((doc, index) => (
                <li key={index} className="doc__item mb-10 d-flex flex-row align-center u-justify-between">
                  <span className="doc__name">{doc.legenda} ({doc.arquivo.split(".").pop()})</span>
                  <a href={doc.link} download target="_blank" className="doc__link download-link">Download</a>
                </li>
              ))}
            </ul>
          </div>}

          {!docs && <div>Não foi enviado nenhum documento.</div>}
        </Box>}

        <Box title="Tags" defaultOpen={true}>
          {user?.tags?.length <= 0 && <div>Sem tags</div>}

          {user?.tags?.map((tag, index) =>
            <div key={index} className="tag">
              <span>#{tag.name}</span>
            </div>
          )}
        </Box>

        <Box title="Observações" defaultOpen={true}>
          {user?.observations.map((item, index) => {
            return (
              <div className="observation-box text-color">
                <div>
                  <span className="observation-box__author">{item.author}</span>
                </div>
                <p className="observation-box__body">
                  {item.body}
                </p>
              </div>
            );
          })}
        </Box>

        <Box title="Telefones" defaultOpen={true}>
          <div>
            {/* Deixar a listagem dos números aqui */}
            {/* {docs && <div>
                  <ul className="doc__list">
                    {docs?.map((doc, index) => {
                      return (
                        <li key={index} className="doc__item mb-10 d-flex flex-row align-center u-justify-between">
                          <span className="doc__name">{doc.legenda} ({doc.arquivo.split(".").pop()})</span>
                          <a href={doc.download} download className="doc__link download-link">Deletar</a>
                        </li>
                      );
                    })}
                  </ul>
                </div>} */}
          </div>

          <form onSubmit={handleSubmit(sendNumber)}>
            <ul className="phone__list mb-10">
              <li className="phone__item">
                <label className="phone__label">
                  <input className="phone__input" type="radio" name="phone" value="1" {...register("phone")} />
                  <span className="phone__title text-color">Telefone 1</span>
                </label>
              </li>
              <li>
                <label className="phone__label">
                  <input className="phone__input" type="radio" name="phone" value="2" {...register("phone")} />
                  <span className="phone__title text-color">Telefone 2</span>
                </label>
              </li>
              <li>
                <label className="phone__label">
                  <input className="phone__input" type="radio" name="phone" value="3" {...register("phone")} />
                  <span className="phone__title text-color">Telefone 3</span>
                </label>
              </li>
              {errors.phone && <div className="mt-5 text-error">{errors.phone.message}</div>}
            </ul>

            <InputControlledMask control={control} mask="+99 99 9999-9999" label="Add telefone"
              type="text" placeholder="+55 99 9999-9999" name="number" error={errors.number} />

            <div className="d-flex flex-row justify-end">
              <CButton type="submit" color="dark" className="mt-20" disabled={phoneLoading}>{btnLoading}</CButton>
            </div>
          </form>

        </Box>
      </div>
    </div>
  )
}

export default CustomersDetails;